import TrackerUtilService from "./TrackerUtilService";
import _, { isArray, isEmpty, map, size, toString } from "lodash";
import { LIST_LICENSE_PLATE_MULTIPLE } from "../app/modules/truck/_redux/constants";

const trackerUtilService = new TrackerUtilService();

export default {
  getFirmwareInfo(param) {
    let api = `/firmware-management/firmwares`;
    return trackerUtilService.get(api, {
      params: param
    });
  },
  deleteFirmware(id) {
    let api = `/firmware-management/firmwares/${id}`;
    return trackerUtilService.delete(api);
  },
  getListHardwares(params) {
    let api = `/firmware-management/hardwares`;
    return trackerUtilService.get(api, {
      params
    });
  },
  getListFirmwareByHardwareVersion(param, type) {
    let api = `/firmware-management/hardwares/${
      param.hardware_version
    }/firmwares`;
    return trackerUtilService.get(api, {
      params: type
    });
  },
  createDevice(data) {
    let api = `/tracker-management/trackers`;
    return trackerUtilService.post(api, data);
  },
  updateDevice(data) {
    let api = `/tracker-management/trackers`;
    return trackerUtilService.put(api, data);
  },
  getListDevices(param) {
    let api = `/tracker-management/trackers`;
    return trackerUtilService.get(api, {
      params: param
    });
  },
  downloadListDevices(param) {
    let api = `/tracker-management/trackers/download`;
    return trackerUtilService.get(api, {
      params: param
    });
  },
  getLisTruckRegister(param) {
    let api = `/truck-management/truck-registering`;
    return trackerUtilService.get(api, {
      params: param
    });
  },
  fowardToTc(data) {
    let api = `/truck-management/setup-forward-data`;
    return trackerUtilService.put(api, data);
  },
  callLog(data) {
    let api = `/truck-management/call-log`;
    return trackerUtilService.post(api, data);
  },
  addTruckRegister(data) {
    let api = `/truck-management/truck-registering`;
    return trackerUtilService.post(api, data);
  },
  deleteTruckRegister(license_plates) {
    let api = `/truck-management/truck-registering/${license_plates}`;
    return trackerUtilService.delete(api);
  },
  deleteDevice(device_id) {
    let api = `/tracker-management/trackers/${device_id}`;
    return trackerUtilService.delete(api);
  },
  getTruckerInfo(param) {
    let api = `/driver-management/drivers`;
    return trackerUtilService.get(api, {
      params: param
    });
  },
  getMonitoringInfo(param) {
    let api = `/truck-state/geojson`;
    return trackerUtilService.get(api, {
      params: param
    });
  },
  getMonitoringInfoV2(param) {
    let api = `/truck-state/geojson-v2`;
    return trackerUtilService.get(api, {
      params: param
    });
  },
  getListTruck(param) {
    let api = `/truck-management/trucks`;
    return trackerUtilService.get(api, {
      params: param
    });
  },
  getListOfflineTruck() {
    let api = `/truck-management/offline-trucks`;
    return trackerUtilService.get(api);
  },
  getListTruckEx(param) {
    let api = `/truck-management/truck-trackers`;
    return trackerUtilService.get(api, {
      params: param
    });
  },
  getListDownloadTruckEx(param) {
    let api = `/truck-management/truck-trackers/download`;
    return trackerUtilService.get(api, {
      params: param
    });
  },
  getListLicensePlate() {
    let api = `/truck-management/trucks/license-plates`;
    return trackerUtilService.get(api);
  },
  getAllLicensePlate() {
    let api = `/api/v1/internal/truck/license-plates`;
    return trackerUtilService.get(api);
  },
  getListLicensePlateWithDeletedTrucks() {
    let api = `/truck-management/all-trucks/license-plates`;
    return trackerUtilService.get(api);
  },
  getTrackerUsageLogMonitoringScreen() {
    let api = `/usage-log/monitoring-screen`;
    return trackerUtilService.get(api);
  },
  assignDeviceTiTruck(data) {
    let api = `/truck-management/trucks`;
    return trackerUtilService.put(api, data);
  },
  getTruckJourney(param) {
    let param_format = {
      license_plate: param.license_plate,
      from: param.from,
      to: param.to
    };
    let api = `/route`;
    return trackerUtilService.get(api, {
      params: param_format
    });
  },
  getTruckJourneyGeo(param) {
    let param_format = {
      license_plate: param.license_plate,
      from: param.from,
      to: param.to
    };
    let api = `/route/geojson`;
    return trackerUtilService.get(api, {
      params: param_format
    });
  },
  getTruckDetailInfo(param) {
    let api = `/truck-state/${param}`;
    return trackerUtilService.get(api);
  },
  getTruckHistoryLog(params) {
    let api = `/truck-state/his-log`;
    return trackerUtilService.get(api, { params });
  },
  getFirmwareUpdateHistory(imei) {
    let api = `/tracker-management/trackers/${imei}/update-history`;
    return trackerUtilService.get(api);
  },
  getTruckBrokenHistory(license_plate) {
    let api = `/truck-management/broken-histories?license_plate=${license_plate}`;
    return trackerUtilService.get(api);
  },
  saveTruckBrokenHistory(data) {
    let api = `/truck-management/broken-info`;
    return trackerUtilService.post(api, data);
  },
  deleteVehicle(id) {
    let api = `/truck-management/trucks/${id}/tracker`;
    return trackerUtilService.delete(api);
  },
  getListLicensePlates() {
    let api = `/truck-management/trucks/license-plates`;
    return (api = trackerUtilService.get(api));
  },
  getTruckStopPointName(param) {
    if (param) {
      let api = `/stop-points?type=${param?.type}`;
      return (api = trackerUtilService.get(api));
    } else {
      let api = `/stop-points`;
      return (api = trackerUtilService.get(api));
    }
  },
  getErpCompanies() {
    let api = `/erp-companies`;
    return (api = trackerUtilService.get(api));
  },
  createErpTruck(data) {
    let api = `/truck-management/erp-truck`;
    return trackerUtilService.post(api, data);
  },
  getEnterpriseReport(report_type, param) {
    let api;
    switch (report_type) {
      case "type1": {
        api = `/report/enterprise/activity-summary`;
        break;
      }
      case "type2": {
        api = `/report/enterprise/activity-detail`;
        break;
      }
      case "type3": {
        api = `/report/enterprise/stop-detail`;
        break;
      }
      case "type4": {
        api = `/report/enterprise/stop-summary`;
        break;
      }
      case "type5": {
        api = `/report/enterprise/stop-violation`;
        break;
      }
      case "type6": {
        api = `/report/enterprise/lost-signal`;
        break;
      }
      case "type7": {
        api = `/report/enterprise/cumulative-km`;
        if (param.merge_vehicle) {
          api = `/report/enterprise/summed-cumulative-km`;
        }
        break;
      }
      case "type8": {
        api = `/report/enterprise/driving-continuous`;
        break;
      }

      case "TEN_HOURS": {
        api = `/report/enterprise/driver-driving-continuous`;
        break;
      }

      case "48h": {
        api = `/report/enterprise/48h`;
        break;
      }

      case "type9": {
        api = `/report/enterprise/driver-activity-summary`;
        break;
      }
      default:
        break;
    }
    if (size(param.station_ids) > 0) {
      param.station_ids = toString(map(param.station_ids, x => x));
    }
    if (size(param.region_ids) > 0) {
      param.region_ids = toString(map(param.region_ids, x => x));
    }
    if (size(param.province_ids) > 0) {
      param.province_ids = toString(map(param.province_ids, x => x));
    }
    return trackerUtilService.get(api, {
      params: param
    });
  },
  getLinkDownloadEnterpriseReport: function (report_type, param) {
    let api;
    switch (report_type) {
      case "type1": {
        api = `/report/enterprise/activity-summary/download?`;
        break;
      }
      case "type2": {
        api = `/report/enterprise/activity-detail/download?`;
        break;
      }
      case "type3": {
        api = `/report/enterprise/stop-detail/download?`;
        break;
      }
      case "type4": {
        api = `/report/enterprise/stop-summary/download?`;
        break;
      }
      case "type5": {
        api = `/report/enterprise/stop-violation/download?`;
        break;
      }
      case "type6": {
        api = `/report/enterprise/lost-signal/download?`;
        break;
      }
      case "type7": {
        api = `/report/enterprise/cumulative-km/download?`;
        if (param.merge_vehicle) {
          api = `/report/enterprise/summed-cumulative-km/download?`;
        }
        break;
      }
      case "type8": {
        api = `/report/enterprise/driving-continuous/download?`;
        break;
      }
      default: {
        break;
      }
    }
    if (size(param.station_ids) > 0) {
      param.station_ids = toString(map(param.station_ids, x => x));
    }
    if (size(param.region_ids) > 0) {
      param.region_ids = toString(map(param.region_ids, x => x));
    }
    if (size(param.province_ids) > 0) {
      param.province_ids = toString(map(param.province_ids, x => x));
    }
    return trackerUtilService.get(api, {
      params: param
    });
  },

  getReport09: (report_type, param) => {
    let api;
    switch (report_type) {
      case "type1": {
        api = `/report/mt-09/violate-speed-over-details?`;
        break;
      }
      case "type2": {
        api = `/report/mt-09/violate-speed-over-summaries?`;
        break;
      }

      case "type3": {
        api = `/report/mt-09/violate-driving-continuous?`;
        api += `&drive_time=${param.drive_time || 0}`;
        break;
      }
      case "type4": {
        api = `/report/mt-09/violate-driving-in-day?&drive_time=600`;
        break;
      }
      case "type5": {
        api = `/report/mt-09/violate-summaries?`;
        break;
      }
      case "type6": {
        api = `/report/mt-09/violate-transfers?`;
        break;
      }
    }
    if (
      report_type === "type1" ||
      report_type === "type3" ||
      report_type === "type4"
    ) {
      if (param.license_plate) {
        api = api + `&license_plate=${param.license_plate}`;
      }
    } else if (isArray(param.license_plate) && size(param.license_plate) > 0) {
      api =
        api +
        `&license_plates=${toString(map(param.license_plate, x => x.value))}`;
    }
    if (param.from && param.to) {
      api = api + `&from=${param.from}&to=${param.to}`;
    }
    api = `${api}&page=${param.page}&size=${param.size}`;
    return trackerUtilService.get(api);
  },

  reportTruckEx: (type, params) => {
    let license_plate = params.license_plate;
    if (license_plate && typeof license_plate !== "string") {
      if (size(license_plate) > 0) {
        if (type !== "getSummaryReportByVehicle") {
          license_plate = license_plate[0];
        } else {
          license_plate = toString(map(license_plate, x => x.value));
        }
      } else {
        license_plate = "";
      }
    }
    let api;
    switch (type) {
      case "getVehicleJourney":
        api = `/report/mt-73/truck-journey?`;
        api = license_plate ? api + `license_plate=${license_plate}` : api;
        break;
      case "getVehicleSpeed":
        api = `/report/mt-73/truck-speeds?`;
        api = license_plate ? api + `&license_plate=${license_plate}` : api;
        break;
      case "getVehicleOverSpeed":
        api = `/report/mt-73/speed-violate?`;
        api = license_plate ? api + `&license_plate=${license_plate}` : api;
        break;
      case "getDriveContinuous":
        api = `/report/mt-73/driving-continuous?`;
        api = api + `&drive_time=${params.driveContinuous}`;
        if (params.username) api = api + `&username=${params.username}`;
        break;
      case "getVehicleStop":
        api = `/report/mt-73/stops?`;
        api = license_plate ? api + `&license_plate=${license_plate}` : api;
        break;
      case "getSummaryReportByVehicle":
        api = `/report/mt-73/truck-summary-report?`;
        api = license_plate ? api + `&license_plates=${license_plate}` : api;
        break;
      case "getSummaryReportByDriver":
        api = `/report/mt-73/driver-summary-report?`;
        if (!isEmpty(params.username)) {
          api = api + `usernames=${params.username}`;
        }
        break;
      default:
        return;
    }
    if (params.from && params.to) {
      api = api + `&from=${params.from}&to=${params.to}`;
    }
    api = `${api}&page=${params.page}&size=${params.size}`;
    return trackerUtilService.get(api);
  },
  downloadReportTruckEx: (type, params) => {
    let license_plate = params.license_plate;
    if (license_plate && typeof license_plate !== "string") {
      if (size(license_plate) > 0) {
        if (type !== "getSummaryReportByVehicle") {
          license_plate = license_plate[0];
        } else {
          license_plate = toString(map(license_plate, x => x.value));
        }
      }
    }
    let api;
    switch (type) {
      case "getVehicleJourney":
        api = `/report/mt-73/truck-journey/download?`;
        api = license_plate ? api + `license_plate=${license_plate}` : api;
        break;
      case "getVehicleSpeed":
        api = `/report/mt-73/truck-speeds/download?`;
        api = license_plate ? api + `&license_plate=${license_plate}` : api;
        break;
      case "getVehicleOverSpeed":
        api = `/report/mt-73/speed-violate/download?`;
        api = license_plate ? api + `&license_plate=${license_plate}` : api;
        break;
      case "getDriveContinuous":
        api = `/report/mt-73/driving-continuous/download?`;
        api = api + `&drive_time=${params.driveContinuous}`;
        if (params.username) api = api + `&username=${params.username}`;
        break;
      case "getVehicleStop":
        api = `/report/mt-73/stops/download?`;
        api = license_plate ? api + `&license_plate=${license_plate}` : api;
        break;
      case "getSummaryReportByVehicle":
        api = `/report/mt-73/truck-summary-report/download?`;
        api = license_plate ? api + `&license_plates=${license_plate}` : api;
        break;
      case "getSummaryReportByDriver":
        api = `/report/mt-73/driver-summary-report/download?`;
        if (!isEmpty(params.username)) {
          api = api + `&usernames=${params.username}`;
        }
        break;
      default:
        return;
    }
    if (params.from && params.to) {
      api = api + `&from=${params.from}&to=${params.to}`;
    }
    api = `${api}&page=${params.page}&size=${params.size}`;
    return trackerUtilService.get(api);
  },
  reportTruck: (type, data) => {
    let license_plate = data.license_plate
      ? typeof data.license_plate === "string"
        ? data.license_plate
        : type === "getSummaryReportByVehicle"
          ? _.size(data.license_plate)
            ? data.license_plate
            : undefined
          : _.size(data.license_plate)
            ? data.license_plate[0]
            : undefined
      : undefined;
    let api;
    switch (type) {
      case "getVehicleJourney":
        api = `/report/mt-73/truck-journey?`;
        api = license_plate ? api + `license_plate=${license_plate}` : api;
        break;
      case "getVehicleSpeed":
        api = `/report/mt-73/truck-speeds?`;
        api = license_plate ? api + `&license_plate=${license_plate}` : api;
        break;
      case "getVehicleOverSpeed":
        api = `/report/mt-73/speed-violate?`;
        api = license_plate ? api + `&license_plate=${license_plate}` : api;
        break;
      case "getDriveContinuous":
        api = `/report/mt-73/driving-continuous?`;
        api = api + `&drive_time=${data.drivecontinuous_hour === 1 ? 10 : 240}`;
        if (data.username) api = api + `&username=${data.username}`;
        break;
      case "getVehicleStop":
        api = `/report/mt-73/stops?`;
        api = license_plate ? api + `&license_plate=${license_plate}` : api;
        break;
      case "getSummaryReportByVehicle":
        api = `/report/mt-73/truck-summary-report?`;
        api = license_plate ? api + `&license_plate=${license_plate}` : api;
        break;
      case "getSummaryReportByDriver":
        api = `/report/mt-73/driver-summary-report?`;
        if (!isEmpty(data.user_drive)) {
          api = api + `&usernames=${data.user_drive}`;
        }
        break;
      default:
        return;
    }
    if (data.startTime) {
      api = api + `&from=${data.startTime}`;
    }
    if (data.endTime) {
      api = api + `&to=${data.endTime}`;
    }
    if (data.param) {
      api = `${api}&page=${data.param.page}&size=${data.param.size}`;
    }
    return trackerUtilService.get(api);
  },
  downloadReport: (type, data) => {
    let license_plate = data.license_plate
      ? typeof data.license_plate === "string"
        ? data.license_plate
        : type === "getSummaryReportByVehicle"
          ? _.size(data.license_plate)
            ? data.license_plate
            : undefined
          : _.size(data.license_plate)
            ? data.license_plate[0]
            : undefined
      : undefined;
    let api;
    switch (type) {
      case "getVehicleJourney":
        api = `/report/mt-73/truck-journey/download?`;
        api = license_plate ? api + `license_plate=${license_plate}` : api;
        break;
      case "getVehicleSpeed":
        api = `/report/mt-73/truck-speeds/download?`;
        api = license_plate ? api + `&license_plate=${license_plate}` : api;
        break;
      case "getVehicleOverSpeed":
        api = `/report/mt-73/speed-violate/download?`;
        api = license_plate ? api + `&license_plate=${license_plate}` : api;
        break;
      case "getDriveContinuous":
        api = `/report/mt-73/driving-continuous/download?`;
        api = api + `&drive_time=${data.drivecontinuous_hour === 1 ? 10 : 240}`;
        if (data.username) api = api + `&username=${data.username}`;
        break;
      case "getVehicleStop":
        api = `/report/mt-73/stops/download?`;
        api = license_plate ? api + `&license_plate=${license_plate}` : api;
        break;
      case "getSummaryReportByVehicle":
        api = `/report/mt-73/truck-summary-report/download?`;
        api = license_plate ? api + `&license_plate=${license_plate}` : api;
        break;
      case "getSummaryReportByDriver":
        api = `/report/mt-73/driver-summary-report/download?`;
        if (!isEmpty(data.user_drive)) {
          api = api + `&username=${data.user_drive}`;
        }
        break;
      default:
        return;
    }
    if (data.startTime) {
      api = api + `&from=${data.startTime}`;
    }
    if (data.endTime) {
      api = api + `&to=${data.endTime}`;
    }
    return trackerUtilService.get(api);
  },
  getReportInfo: (report_type, param) => {
    const DRIVER_TIME_FROM_DEFAULT = 0;
    let license_plate = param.license_plate
      ? typeof param.license_plate === "string"
        ? param.license_plate
        : _.includes(LIST_LICENSE_PLATE_MULTIPLE, report_type)
          ? _.size(param.license_plate)
            ? param.license_plate
            : undefined
          : _.size(param.license_plate)
            ? param.license_plate[0]
            : undefined
      : undefined;
    let api;
    switch (report_type) {
      case "type1": {
        api = `/report/mt-09/violate-speed-over-details?`;
        break;
      }

      case "type2": {
        api = `/report/mt-09/violate-speed-over-summaries?`;
        break;
      }

      case "type3": {
        api = `/report/mt-09/violate-driving-continuous?`;
        api =
          api +
          `&drive_time=${
            param.drive_time_from
              ? param.drive_time_from
              : DRIVER_TIME_FROM_DEFAULT
          }`;
        break;
      }

      case "type4": {
        api = `/report/mt-09/violate-driving-in-day?&drive_time=600`;
        break;
      }
      case "type5": {
        api = `/report/mt-09/violate-summaries?`;
        break;
      }
      case "type6": {
        api = `/report/mt-09/violate-transfers?`;
        break;
      }
    }
    if (param.from_date) {
      api = api + `&from=${param.from_date}`;
    }
    if (param.to_date) {
      api = api + `&to=${param.to_date}`;
    }
    if (report_type === "type1" || report_type === "type4") {
      if (license_plate) {
        api = api + `&license_plate=${license_plate}`;
      }
    } else {
      if (license_plate) {
        api = api + `&license_plates=${license_plate}`;
      }
    }
    if (param.limit) {
      api = api + `&size=${param.limit}`;
    }
    if (param.offset) {
      api = api + `&page=${param.offset}`;
    }
    return trackerUtilService.get(api);
  },
  downloadReport09Ex: (report_type, param) => {
    const DRIVER_TIME_FROM_DEFAULT = 0;

    let api;
    switch (report_type) {
      case "type1": {
        api = `/report/mt-09/violate-speed-over-details/download?`;
        break;
      }

      case "type2": {
        api = `/report/mt-09/violate-speed-over-summaries/download?`;
        break;
      }

      case "type3": {
        api = `/report/mt-09/violate-driving-continuous/download?`;
        api =
          api +
          `&drive_time=${
            param.drive_time ? param.drive_time : DRIVER_TIME_FROM_DEFAULT
          }`;
        break;
      }

      case "type4": {
        api = `/report/mt-09/violate-driving-in-day/download?&drive_time=600`;
        break;
      }
      case "type5": {
        api = `/report/mt-09/violate-summaries/download?`;
        break;
      }
      case "type6": {
        api = `/report/mt-09/violate-transfers/download?`;
        break;
      }
    }
    if (
      report_type === "type1" ||
      report_type === "type3" ||
      report_type === "type4"
    ) {
      if (param.license_plate) {
        api = api + `&license_plate=${param.license_plate}`;
      }
    } else if (isArray(param.license_plate) && size(param.license_plate) > 0) {
      api =
        api +
        `&license_plates=${toString(map(param.license_plate, x => x.value))}`;
    }
    if (param.from && param.to) {
      api = api + `&from=${param.from}&to=${param.to}`;
    }
    api = `${api}&page=${param.page}&size=${param.size}`;
    return trackerUtilService.get(api);
  },
  downloadReport09: (report_type, param) => {
    const DRIVER_TIME_FROM_DEFAULT = 0;
    let license_plate = param.license_plate
      ? typeof param.license_plate === "string"
        ? param.license_plate
        : _.includes(LIST_LICENSE_PLATE_MULTIPLE, report_type)
          ? _.size(param.license_plate)
            ? param.license_plate
            : undefined
          : _.size(param.license_plate)
            ? param.license_plate[0]
            : undefined
      : undefined;
    let api;
    switch (report_type) {
      case "type1": {
        api = `/report/mt-09/violate-speed-over-details/download?`;
        break;
      }

      case "type2": {
        api = `/report/mt-09/violate-speed-over-summaries/download?`;
        break;
      }

      case "type3": {
        api = `/report/mt-09/violate-driving-continuous/download?`;
        api =
          api +
          `&drive_time=${
            param.drive_time_from
              ? param.drive_time_from
              : DRIVER_TIME_FROM_DEFAULT
          }`;
        break;
      }

      case "type4": {
        api = `/report/mt-09/violate-driving-in-day/download?&drive_time=600`;
        break;
      }
      case "type5": {
        api = `/report/mt-09/violate-summaries/download?`;
        break;
      }
      case "type6": {
        api = `/report/mt-09/violate-transfers/download?`;
        break;
      }
    }
    if (param.from_date) {
      api = api + `&from=${param.from_date}`;
    }
    if (param.to_date) {
      api = api + `&to=${param.to_date}`;
    }
    if (report_type === "type1" || report_type === "type4") {
      if (license_plate) {
        api = api + `&license_plate=${license_plate}`;
      }
    } else {
      if (license_plate) {
        api = api + `&license_plates=${license_plate}`;
      }
    }
    if (param.limit) {
      api = api + `&size=${param.limit}`;
    }
    if (param.offset) {
      api = api + `&page=${param.offset}`;
    }
    return trackerUtilService.get(api);
  },
  getCodeJournal(param) {
    let api = `/cod/journal?user_id=${param.userId}&device_id=${
      param.deviceId
    }&from=${param.from}&to=${param.to}`;
    return (api = trackerUtilService.get(api));
  },
  getListCod() {
    let api = `/cod/list-cods`;
    return (api = trackerUtilService.get(api));
  },
  getListDeviceByCod(userId) {
    let api = `/cod/${userId}/devices`;
    return (api = trackerUtilService.get(api));
  },
  getTruckGpsDashboard() {
    let api = `/tracker-report`;
    return trackerUtilService.get(api);
  },
  getTruckInstImg(trackerId) {
    let api = `/tracker-management/trackers/${trackerId}/inst-img`;
    return trackerUtilService.get(api);
  },
  removeTracker(imei) {
    let api = `/truck-management/trucks/tracker?imei=${imei}`;
    return trackerUtilService.delete(api);
  },
  getUserStation() {
    let api = `/stations`;
    return trackerUtilService.get(api);
  },
  getSimCards(param) {
    let api = `/sim-cards`;
    return trackerUtilService.get(api, {
      params: param
    });
  },
  getLinkDownloadSimCards(param) {
    let api = `/sim-cards/download`;
    return trackerUtilService.get(api, {
      params: param
    });
  },
  updateSimCards: param => {
    let api = `/sim-cards`;
    // if (param.id) delete param.id;
    return trackerUtilService.put(api, param);
  },
  createSimCards: data => {
    let api = `/sim-cards`;
    return trackerUtilService.post(api, data);
  },
  deleteSimCards: id => {
    let api = `/sim-cards/${id}`;
    return trackerUtilService.delete(api);
  },
  changeTruckStation(data) {
    let api = `/truck-management/truck/mgmt-station`;
    return trackerUtilService.put(api, data);
  },

  getTruckTemperatureLogs(params) {
    const api = "sensor-logs/temper/log-latest";
    return trackerUtilService.get(api, {
      params
    });
  },

  getTruckTemperatureLicense(params) {
    const api = "sensor-logs/temper/license-plate";
    return trackerUtilService.get(api, {
      params
    });
  },

  getTruckTemperatureImei(params) {
    const api = "sensor-logs/temper/imei";
    return trackerUtilService.get(api, {
      params
    });
  },

  convertLicenseToImei(params) {
    const api = "sensor-logs/temper/license-plate/covert";
    return trackerUtilService.get(api, {
      params
    });
  },

  getTruckTemperatureChart(params) {
    const api = "/sensor-logs/temper/log";
    return trackerUtilService.get(api, {
      params
    });
  },

  deleteTruckTemperatureLogs(imei) {
    const api = `sensor-logs/temper?imei=${imei}`;
    return trackerUtilService.delete(api);
  },

  getTempSensorHistory(imei) {
    const api = "/sensor-logs/temper/history-sensor";
    return trackerUtilService.get(api, {
      params: { imei }
    });
  },

  createTempSensor(data) {
    const api = "/sensor-logs/temper/sensors";
    return trackerUtilService.post(api, data);
  },

  updateTempSensor(id, data) {
    const api = `/sensor-logs/temper/sensors/${id}`;
    return trackerUtilService.put(api, data);
  },

  getTemperatureIdSim() {
    const api = "sensor-logs/temper/id-sim";
    return trackerUtilService.get(api);
  },

  getTruckKpiGps(params) {
    const api = "/api/v1/kpi";
    return trackerUtilService.get(api, {
      params
    });
  }
};
